import React, { useEffect, useState } from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentUser } from '../features/Auth/authSlice';
// import CustomDialogBox  from '../common/CustomDialogBox';
import ShabashTable from '../features/Shabash/components/ShabashTable';
import SearchBar from '../features/Delight/components/DelightsData/SearchBar';
import { variants } from '../variants/variants';
import { useGetAllNominationsQuery } from '../features/Shabash/shabashApiSlice';
import ShabashOverview from '../features/Shabash/ShabashOverview/ShabashOverview';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@emotion/react';

const Shabash = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  return (
    <>
      <Grid
        sx={{
          border: isSm ? 0 : 1,
          backgroundColor: isSm ? '' : '#EEF5FF',
          borderRadius: '10px',
          padding: isSm ? 0 : 1,
          height: 'calc(100vh - 80px)',
          border: 1,
          borderColor: 'divider',
        }}
      >
        <Outlet />
      </Grid>
    </>
  );
};

export default Shabash;
